import api from './api/client';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { ConfigProviders } from './contexts/ConfigContext';
import { PersistGate } from 'redux-persist/integration/react';

import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store, persister } from './store';
import { FarmProfileProvider } from './contexts/FarmProfileContext';
import { SocketProvider } from './contexts/SocketContext';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';

ReactDOM.render(
    <Provider store={store}>
        <ConfigProviders>
            <FarmProfileProvider>
                <PersistGate loading={null} persistor={persister}>
                    <ErrorBoundary>
                        <SocketProvider>
                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorPrimary: '#279e6c' // 🔥 change this (main color)
                                    },
                                    locale: enUS
                                }}
                                locale={enUS}
                            >
                                <App />
                            </ConfigProvider>
                        </SocketProvider>
                    </ErrorBoundary>
                </PersistGate>
            </FarmProfileProvider>
        </ConfigProviders>
    </Provider>,
    document.getElementById('root')
);

reportWebVitals();

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/serviceWorker.js')
            .then((registration) => {
})
            .catch((error) => {
});
    });
}

// put this in index.js
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
    if (args[0]?.includes?.('ResizeObserver loop')) return;
    resizeObserverErr(...args);
};
